export default __webpack_public_path__ + "static/media/delete_position.bbaeac16.svg";